import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';

@Injectable({
  providedIn: 'root'
})
export class GenericTableService {
  subscription_GetLoading: Subscription;
  public isLoading$: Subject<boolean> = new Subject<boolean>();

  constructor() {
   
   }

  // setLoading(resp) {
  //   this.isLoading$.next(resp);
  // }

  // getLoading() {
  //   return this.isLoading$.asObservable();
  // }

  

}
